import { api } from "@/client/api"
import router from "@/router"

export default {

    debug(message, name, tags) {
        this.log("debug", message, name, tags)
    },

    error(message, name, tags) {
        this.log("error", message, name, tags)
    },

    info(message, name, tags) {
        this.log("info", message, name, tags)
    },

    trace(message, name, tags) {
        this.log("trace", message, name, tags)
    },

    warn(message, name, tags) {
        this.log("warn", message, name, tags)
    },

    log(level, message, name, tags) {
        api.post(`/log`, {
            clientDateTime: new Date().toISOString(),
            level: level,
            message: message,
            name: name || router.currentRoute?.name || "main",
            source: "aspen-dental-apply",
            tags: tags,
        })
    },
}
